module.exports = __webpack_public_path__ + "static/media/Sedan.a1805e65.png";